import { Injectable, inject } from '@angular/core';
import { from, map } from 'rxjs';
import { Featurebase } from '../featurebase';
import { loadScript } from '../lib/load-script';
import { ObservableDataLoaderService } from './observable-data-loader.service';

@Injectable({
  providedIn: 'root',
})
export class FeaturebaseService implements Featurebase {
  private loader = inject(ObservableDataLoaderService);

  public get() {
    return this.loader.get('featurebase', () => {
      const id = 'featurebase-sdk';
      window['Featurebase'] = function () {
        (window['Featurebase'].q = window['Featurebase'].q || []).push(window, document);
      };
      return from(loadScript('https://do.featurebase.app/js/sdk.js', { id })).pipe(map(() => window['Featurebase']));
    });
  }
}
